import { TopicMappingOrchestrator } from '@src/services/transcript/TopicMappingOrchestrator';
import { TopicTaggingService } from '@src/services/transcript/TopicTaggingService';
import { useDatoClient } from '@src/stores-v2/StoreContext';
import { useMemo } from 'react';

/**
 * DI seam for the topic-tagging stack. The one and only place
 * `TopicTaggingService` and `TopicMappingOrchestrator` are instantiated, and
 * the one and only place `process.env.REACT_APP_API_URL` is read from the
 * topic-tagging path. Memoized on the DatoCMS client identity — stable for the
 * lifetime of a session.
 */
export function useTopicTaggingOrchestrator(): TopicMappingOrchestrator {
  const datoClient = useDatoClient();
  return useMemo(() => {
    const apiUrl = process.env.REACT_APP_API_URL ?? '';
    const tagging = new TopicTaggingService(apiUrl);
    return new TopicMappingOrchestrator(tagging, datoClient.storyRepository);
  }, [datoClient]);
}
